<div class="overlay">
  <button class="backdrop" (click)="close()" aria-label="Dialog schließen" tabindex="-1"></button>
  <dialog class="panel" open aria-modal="true" aria-label="Umfrage">
    <button class="close-btn" (click)="close()" aria-label="Schließen">&times;</button>
    @if (isLoading()) {
      <div class="loader-wrapper">
        <app-loader></app-loader>
      </div>
    }
    <iframe #frame src="about:blank" class="frame" title="Umfrage" (load)="onFrameLoad()"></iframe>
  </dialog>
</div>
